// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"722":"190ec858","872":"6f092fe9","895":"faea67ec"}[chunkId] + ".chunk.css";
};